import { Fragment, useState } from 'react';
import { t } from '@lingui/core/macro';
import { IconButton } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { SelectTemplateDialog } from 'app/domains/templates';
export function SidebarMenuCreateDocument() {
    const [renderTemplateDialog, setRenderTemplateDialog] = useState(false);
    const showTemplateDialog = () => setRenderTemplateDialog(true);
    const hideTemplateDialog = () => setRenderTemplateDialog(false);
    return (<Fragment>
      <IconButton size="small" aria-label={t({
            message: 'Create document',
            comment: 'Sidebar header - Create document button',
        })} onClick={showTemplateDialog}>
        <Falcon icon="plus"/>
      </IconButton>
      {renderTemplateDialog && <SelectTemplateDialog onClose={hideTemplateDialog}/>}
    </Fragment>);
}
